
import React, { useState } from 'react';
import { FormControl, InputLabel, Select, MenuItem, makeStyles } from '@material-ui/core';
import ReportLayoutPage from './ReportLayoutPage';
import ChartReportFilter from './ChartReportFilter';
import Graph from './Graph';
import { useAttributePreference } from '../common/preferences';
import { formatDate } from '../common/formatter';
import { speedConverter } from '../common/converter';
import t from '../common/localization';


const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
     display: "flexEnd",
    flexDirection: "row",
    textAlign: "right",
  },
   selectField: {
      textAlign: "left",
      color: 'white',
      height: "50px",
      variant: "standard",
      margin: "5px",
      width:"20%",
    },
   menuItemCss: {
      '&.Mui-selected': {
            background: "#361DDB",
            color:'white'
      },
      '&:hover': {
            background: "#b3aeae",
            color:'black'
      },
     },
    }));

 const Filter = ({ setItems, setType, type }) => {

  const speedUnit = useAttributePreference('speedUnit');

  const handleSubmit = async (deviceId, from, to, mail, headers) => {
    const query = new URLSearchParams({ deviceId, from, to, mail });
    const response = await fetch(`/api/reports/route?${query.toString()}`, { headers });
    if (response.ok) {
      const positions = await response.json();
      let formattedPositions = positions.map(position => {
        return {
          speed: Number(speedConverter(position.speed, speedUnit)),
          altitude: position.altitude,
          accuracy: position.accuracy,
          fixTime: formatDate(position.fixTime, "MMM D, hh:mm A"),
          fuel: position.attributes.fuel && Number(position.attributes.fuel),
          temp1: position.attributes.temp1,
          temp2: position.attributes.temp2,
          mtCustom1: position.attributes.mtCustom1,
          mtCustom2: position.attributes.mtCustom2,
        }
      });
      setItems(formattedPositions);
    }
  }
  return (
    <>
      <ChartReportFilter type = {type} setType = {setType} handleSubmit={handleSubmit} showOnly reportHeader="Device Chart"  />
    </>
  )
}

const ChartType = ({ type, setType }) => {
  const classes = useStyles();
  // console.log();

  return (
      <div className={classes.root}>
     <FormControl className={classes.selectField}>
      <InputLabel>{t('reportChartType')}</InputLabel>
      <Select
      disableUnderline={true}
      displayEmpty
      value={type} onChange={e => setType(e.target.value)}>
        <MenuItem className ={classes.menuItemCss} value="speed">{t('positionSpeed')}</MenuItem>
        <MenuItem className ={classes.menuItemCss} value="accuracy">{t('positionAccuracy')}</MenuItem>
        <MenuItem className ={classes.menuItemCss} value="altitude">{t('positionAltitude')}</MenuItem>
        <MenuItem className ={classes.menuItemCss} value="fuel">{t('fuel')}</MenuItem>
        <MenuItem className ={classes.menuItemCss} value="temp1">{t('positionTemp1')}</MenuItem>
        <MenuItem className ={classes.menuItemCss} value="temp2">{t('positionTemp2')}</MenuItem>
        <MenuItem className ={classes.menuItemCss} value="mtCustom1">{t('mtCustom1')}</MenuItem>
        <MenuItem className ={classes.menuItemCss} value="mtCustom2">{t('mtCustom2')}</MenuItem>
      </Select>
    </FormControl>
    </div>
  )
}


const ChartReportPage = () => {
  
  const [items, setItems] = useState([]);
  const [type, setType] = useState('speed');
  return (
    <>
      <ReportLayoutPage filter={ 
        <Filter setItems={setItems}  type = {type} setType = {setType}>
        </Filter>
      }>
        <Graph items={items} type={type} />
      </ReportLayoutPage>
    </>
  )
}

export default ChartReportPage;
